import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { SITE, NAV_LINKS } from "../lib/site";
import { Button } from "./ui/button";
import { Input } from "./ui/input";export const Footer = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email, source: "footer" });
      toast.success("You're in. A warm welcome from Aima.");
      setEmail("");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer
      data-testid="footer"
      className="bg-[#5fa292] text-[#faf9f6] mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-24">
        <div className="grid lg:grid-cols-3 gap-12 lg:gap-16">
          <div>
            <img
              src={SITE.logoWhite}
              alt="Aima Women's Health"
              className="h-28 md:h-32 w-auto -ml-2"
            />
            <p className="mt-6 text-sm leading-relaxed text-[#faf9f6]/80 max-w-xs font-normal">
              Holistic hormone health for women who are done being dismissed.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8">
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-[#faf9f6]/70 mb-4">
                Explore
              </p>
              <ul className="space-y-3">
                {NAV_LINKS.map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-sm text-[#faf9f6]/90 hover:text-white transition-colors font-normal"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-[#faf9f6]/70 mb-4">
                Connect
              </p>
              <ul className="space-y-3">
                <li>
                  <a
                    href={`mailto:${SITE.email}`}
                    data-testid="footer-email"
                    className="flex items-center gap-2 text-sm text-[#faf9f6]/90 hover:text-white font-normal break-all"
                  >
                    <Mail size={14} className="shrink-0" /> {SITE.email}
                  </a>
                </li>
                <li>
                  <a
                    href={SITE.instagram}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="footer-instagram"
                    className="flex items-center gap-2 text-sm text-[#faf9f6]/90 hover:text-white font-normal"
                  >
                    <Instagram size={14} /> @aima.health
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#faf9f6]/70 mb-4">
              The Letter
            </p>
            <p className="text-sm text-[#faf9f6]/85 font-normal mb-5 leading-relaxed">
              Slow, considered notes on hormones, rhythms and reclaiming your
              body. Once a month, never spam.
            </p>
            <form
              data-testid="newsletter-form"
              onSubmit={submit}
              className="flex flex-col sm:flex-row gap-2"
            >
              <Input
                type="email"
                required
                data-testid="newsletter-email-input"
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-white/10 border-white/20 text-white placeholder:text-white/50 focus-visible:ring-white/60"
              />
              <Button
                type="submit"
                disabled={loading}
                data-testid="newsletter-submit"
                className="bg-[#faf9f6] text-[#5fa292] hover:bg-white whitespace-nowrap font-medium"
              >
                {loading ? "Sending..." : "Subscribe"}
              </Button>
            </form>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/15 flex flex-col sm:flex-row justify-between gap-4 text-xs text-[#faf9f6]/60 font-normal">
          <p>© {new Date().getFullYear()} Aima Health · Lara Brown</p>
          <p>
            Holistic guidance · not a substitute for medical care.
          </p>
        </div>
      </div>
    </footer>
  );
};
